"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgKey = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M33.628 14.684l-1.298 1.299 2.309 2.31a1 1 0 01.083 1.32l-.083.094-3.5 3.5a1 1 0 01-1.414 0l-2.31-2.309-2.743 2.744a6.5 6.5 0 01-9.847 8.44 6.5 6.5 0 018.451-9.807l3.317-3.32c.037-.057.081-.112.132-.162l3.5-3.5c.05-.05.105-.095.163-.132l1.86-1.857c.92-.92 2.3.46 1.38 1.38zm-17.31 9.701a4.498 4.498 0 00-.062 6.3 4.5 4.5 0 106.37-6.355 4.5 4.5 0 00-6.308.055zm14.614-6.97L28.846 19.5l1.586 1.586L32.518 19l-1.586-1.586z",
    id: "key_svg__a"
  }));
};

var _default = SvgKey;
exports.default = _default;